import { services } from "@/mocks/homeData";
import { useTranslation } from "react-i18next";

const serviceKeys = ["keyCutting", "cylinders", "masterKey", "repair"] as const;

export default function ServicesGrid() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-950 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 border border-secondary-400/30 text-secondary-300 text-xs md:text-sm font-medium rounded-full whitespace-nowrap">
            {t("services.badge")}
          </span>
          <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 mt-4">
            {t("services.heading")}
          </h2>
          <p className="text-sm md:text-base text-background-50/60 mt-3 max-w-lg mx-auto">
            {t("services.description")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-background-800 rounded-lg p-5 md:p-6 group hover:bg-background-700 transition-colors duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-secondary-500/15 rounded-lg mb-4 group-hover:bg-secondary-500/25 transition-colors">
                <i className={`${service.icon} text-xl md:text-2xl text-secondary-300 group-hover:text-secondary-200 transition-colors`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-background-50 mb-2">
                {t(`services.items.${serviceKeys[index]}.title`)}
              </h3>
              <p className="text-sm text-background-50/60 leading-relaxed">
                {t(`services.items.${serviceKeys[index]}.description`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}